import React from 'react'
import PropTypes from 'prop-types'
import PageTitle from '../features/ui/util/page_title'
import DefaultLayout from '../layouts/default_layout'
import MarketplaceListingCreate from '../features/marketplace_listing_create'
import { connect } from 'react-redux'
import { BREAKPOINT_EXTRA_SMALL } from '../constants'
import { fetchMarketplaceListingAvailableAttributes } from '../actions/marketplace_listing_search'

class MarketplaceListingCreatePage extends React.PureComponent {

  componentDidMount() {
    const { availableAttrs } = this.props
    if (!availableAttrs) this.props.dispatch(fetchMarketplaceListingAvailableAttributes())
  }

  render() {
    const { isXS, params } = this.props

    const itemId = !!params ? params?.id : null
    const title = itemId ? 'Update Listing' : 'Create Listing'

    return (
      <DefaultLayout
        noRightSidebar
        showBackBtn
        title={title}
        page='marketplace-listing-create'
        noPullToRefresh
        sidebarChildren={!isXS ? <MarketplaceListingCreate showForm params={params} /> : undefined }
      >
        <PageTitle path={title} />
        { !isXS && <MarketplaceListingCreate params={params} /> }
        
        {
          isXS &&
          <div className={[_s.d, _s.w100PC, _s.bgPrimary, _s.px15].join(' ')}>
            <MarketplaceListingCreate showForm params={params} />
          </div>
        }
      </DefaultLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

MarketplaceListingCreatePage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default connect(mapStateToProps)(MarketplaceListingCreatePage)